export interface SettingsFormState {
  systemName: string;
  systemDescription: string;
  logoPath: string;
  timezone: string;
  language: string;
  dateFormat: string;
  defaultStatus: string;
  upcomingDays: string;
  overdueReminder: string;
  reminderTime: string;
  allowDuplicateAssignments: boolean;
  autoStatusUpdate: boolean;
  maxFileSize: string;
  allowedFileTypes: string[];
  storageUsedGb: number;
  storageLimitGb: number;
  showQuickTips: boolean;
  darkMode: boolean;
  collapseSidebar: boolean;
}

export interface SettingsActivity {
  id: string;
  actorName: string;
  summary: string;
  createdAt: string | null;
}

export interface VersionInfo {
  version: string;
  lastUpdate: string | null;
}

export const defaultSettingsForm: SettingsFormState = {
  systemName: 'GreenSpace',
  systemDescription: 'Hệ thống quản lý thi công và bảo dưỡng công trình.',
  logoPath: '',
  timezone: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
  language: 'Tiếng Việt',
  dateFormat: 'DD/MM/YYYY',
  defaultStatus: 'Chưa bắt đầu',
  upcomingDays: '7 ngày',
  overdueReminder: 'Hằng ngày',
  reminderTime: '08:00',
  allowDuplicateAssignments: true,
  autoStatusUpdate: true,
  maxFileSize: '50 MB',
  allowedFileTypes: ['PDF', 'DOC', 'DOCX', 'XLS', 'XLSX', 'DWG', 'JPG', 'PNG'],
  storageUsedGb: 0,
  storageLimitGb: 1,
  showQuickTips: true,
  darkMode: false,
  collapseSidebar: true,
};
